/**
 * @generated SignedSource<<0e61ff74b4e2f2419d1197c6f6f1217d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteDataSourceInput = {
  clientMutationId?: string | null;
  orgRelayId: string;
  sourceCalId: string;
};
export type DeleteDataSourceMutation$variables = {
  input: DeleteDataSourceInput;
};
export type DeleteDataSourceMutation$data = {
  readonly deleteDataSource: {
    readonly clientMutationId: string | null;
  } | null;
};
export type DeleteDataSourceMutation = {
  variables: DeleteDataSourceMutation$variables;
  response: DeleteDataSourceMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteDataSourcePayload",
    "kind": "LinkedField",
    "name": "deleteDataSource",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteDataSourceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteDataSourceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "73d143a68f26f5b0125bdbe2fce403f9",
    "id": null,
    "metadata": {},
    "name": "DeleteDataSourceMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteDataSourceMutation(\n  $input: DeleteDataSourceInput!\n) {\n  deleteDataSource(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "ffd686d47b7a04b04571e139bdaa6800";

export default node;
